(() => {
  if (customElements.get('nolya-shipping-protection')) return;
  let running = false;
  let scheduled = false;
  let explicitChoice = null;
  let lastQuantity = null;
  let failedState = null;
  const selector = 'nolya-shipping-protection';
  const preferenceKey = 'nolya_shipping_protection';
  const component = () => document.querySelector(selector);
  const signature = (el) => [el.dataset.goods, el.dataset.preference, el.dataset.lines, explicitChoice].join('|');
  function busy(value) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.toggleAttribute('data-protection-busy', value);
    const toggle = drawer.querySelector('[role="switch"]');
    if (toggle) toggle.disabled = value;
    const checkout = drawer.querySelector('[name="checkout"]');
    if (checkout) checkout.disabled = value || drawer.classList.contains('is-empty');
  }
  function render(cart) {
    const drawer = document.querySelector('cart-drawer');
    const html = cart.sections?.['cart-drawer'];
    if (!drawer || !html) throw new Error('Missing cart section');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.querySelector('#CartDrawer');
    if (!source) throw new Error('Missing cart drawer');
    const active = drawer.classList.contains('active');
    document.getElementById('CartDrawer').innerHTML = source.innerHTML;
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && cart.sections['cart-icon-bubble']) {
      bubble.innerHTML = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
    }
    drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
    if (active && typeof trapFocus === 'function') {
      const focus = drawer.querySelector('[role="switch"]') || drawer.querySelector('.drawer__close');
      trapFocus(drawer.querySelector('.drawer__inner'), focus);
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => { scheduled = false; reconcile(); }, 0);
  }
  async function reconcile() {
    if (running) return;
    const el = component();
    if (!el || failedState === signature(el)) return;
    const hasGoods = el.dataset.goods === 'true';
    const desired = hasGoods && (explicitChoice ?? (el.dataset.preference !== 'off'));
    const lines = el.dataset.lines.split(';').filter(Boolean).map(line => {const i=line.lastIndexOf('=');return {key:line.slice(0,i),quantity:Number(line.slice(i+1))};});
    lastQuantity = Number(el.dataset.quantity);
    const target = desired ? 1 : 0;
    const correct = lines.length === target && (!desired || lines[0].quantity === 1);
    const preference = explicitChoice === null ? null : explicitChoice ? 'on' : 'off';
    if (correct && (!preference || el.dataset.preference === preference)) { explicitChoice = null; return; }
    running = true;
    busy(true);
    el.querySelector('[role="switch"]').setAttribute('aria-checked', String(desired));
    try {
      const updates = {};
      lines.forEach((line,index) => {updates[line.key] = desired && index === 0 ? 1 : 0;});
      if (desired && !lines.length) updates[el.dataset.variant] = 1;
      const payload = {updates,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname};
      if (preference) payload.attributes = {[preferenceKey]:preference};
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      const cart = await response.json();
      if (!response.ok || cart.errors || cart.status) throw new Error('Cart update failed');
      explicitChoice = null;
      lastQuantity = cart.items.filter(item=>String(item.variant_id)===el.dataset.variant).reduce((sum,item)=>sum+item.quantity,0);
      render(cart);
      failedState = null;
    } catch (error) {
      const current = component();
      if (current) {
        current.querySelector('[role="switch"]').setAttribute('aria-checked', String(Number(current.dataset.quantity)>0));
        current.querySelector('[role="status"]').textContent = current.dataset.error;
        failedState = signature(current);
      }
    } finally {
      running = false;
      busy(false);
    }
  }
  customElements.define('nolya-shipping-protection', class extends HTMLElement {
    connectedCallback() {
      this.querySelector('[role="switch"]').addEventListener('click', () => {
        if (running) return;
        explicitChoice = this.querySelector('[role="switch"]').getAttribute('aria-checked') !== 'true';
        failedState = null;
        reconcile();
      });
      if (running) busy(true);
      schedule();
    }
  });
  document.addEventListener('click',event=>{
    if (running && event.target.closest('cart-drawer [name="checkout"],cart-drawer cart-remove-button,cart-drawer quantity-input button')) {
      event.preventDefault();event.stopImmediatePropagation();
    }
  },true);
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{
    if (event.source === 'cart-items' && event.cartData?.items && lastQuantity > 0) {
      const el = component();
      if (el && !event.cartData.items.some(item=>String(item.variant_id)===el.dataset.variant) && event.cartData.items.some(item=>item.requires_shipping)) explicitChoice = false;
    }
    schedule();
  });
})();
